import call from './call';
import handleBase64ZipResponse from "../helpers/handleBase64ZipResponse";
import {SHOW_MSG} from "../types";
import languages from "../language/languages";

export default (form,onFinishCallBack) => async (dispatch,getState) =>
{
    const onResult= (result) =>
    {
        if(result)
        {
            if(result[1].success)
            {
                if(onFinishCallBack)
                    onFinishCallBack();
                let certInfo=result[1].certInfo;
                handleBase64ZipResponse(certInfo.p12, certInfo.alias.concat(".p12"));
                dispatch({type: SHOW_MSG, payload: {message: languages[getState().auth.language].processOk,type:'success'}});
            }
        }
    }
    dispatch(call("CertificateService/generateP12Certificate",form,onResult));
};